<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>Returning to the fantastical land of ‘Solari’, 15-year-old Evie Campbell is left reeling when a shocking turn of events leaves all of the inhabitants in a state of utter devastation. </p>
<p>So intent is she on helping her friends that she remains oblivious to the horror that is unfolding in her own world and to the terrifying ordeal that awaits her return…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?b2a56e72